<template>
  <AccountWrapper>
    <sdCards>
      <template v-slot:title>
        <div class="setting-card-title">
          <sdHeading as="h4">{{ $t('pages.settings.account-settings') }}</sdHeading>
          <span>{{ $t('pages.settings.account-settings-desc') }}</span>
        </div>
      </template>
      <a-row>
        <a-col :xs="24">
          <BasicFormWrapper>
            <a-form :model="formState" @finish="handleFinish">
              <div class="account-form-top">
                <a-row type="flex" justify="center">
                  <a-col :xxl="10" :lg="16" :md="18" :xs="24">
                    <div class="account-form">
                      <a-form-item :label="$t('pages.settings.to-fa-verify')">
                        <a-select v-model:value="formState.two_fa_verify">
                          <a-select-option :value="1">{{ $t('common.active') }}</a-select-option>
                          <a-select-option :value="0">{{ $t('common.passive') }}</a-select-option>
                        </a-select>
                      </a-form-item>
                       <a-form-item :label="$t('pages.settings.email-permit')">
                        <a-select v-model:value="formState.email_permit">
                          <a-select-option :value="1">{{ $t('common.active') }}</a-select-option>
                          <a-select-option :value="0">{{ $t('common.passive') }}</a-select-option>
                        </a-select>
                      </a-form-item>
                      <a-form-item :label="$t('pages.settings.email')" v-if="false">
                        <a-input v-model:value="formState.email" />
                      </a-form-item>
                      <a-form-item>
                        <sdButton size="default" htmlType="submit" type="primary">
                          {{ $t('pages.settings.save-change') }}
                        </sdButton>
                      </a-form-item>
                    </div>
                  </a-col>
                </a-row>
              </div>
            </a-form>
          </BasicFormWrapper>
        </a-col>
      </a-row>
    </sdCards>
  </AccountWrapper>
</template>

<script>
import { AccountWrapper } from './style';
import { BasicFormWrapper } from '../../styled';
import { mapGetters } from 'vuex';

export default {
  name: 'Account',
  components: { AccountWrapper, BasicFormWrapper },
  data() {
    return {};
  },
  methods: {
    handleFinish() {
      const form = {
        two_fa_verify: this.formState.two_fa_verify,
        email: this.formState.email,
        email_permit : this.formState.email_permit
      };
      this.$appAxios.post(this.$endpoints.profile_account_set, form).then((resp) => {
        if (resp.data.status) {
          this.$message.success(this.$t('common.success-message'));
        } else {
          this.$message.error(resp.data.message);
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      formState: 'setting/user_info',
    }),
  },
};
</script>
